'use client';

import { SessionProvider } from 'next-auth/react';
import { Session } from 'next-auth'; // Import Session type
import { ReactNode, useState, useEffect } from 'react';

interface AuthProviderProps {
  children: ReactNode;
  session: Session | null; // Add session prop
}

export function AuthProvider({ children, session }: AuthProviderProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null; // Or a loading spinner
  }

  return <SessionProvider session={session}>{children}</SessionProvider>;
}

export default AuthProvider;
